import $ from 'jquery';
import { closeModal } from '@/function/function.js';

import store_patient from "@/store/mods/clinique/patients"
import store_rendez_vous from '@/store/mods/clinique/rendez_vous'
import { date_lisible, date_rdv_lisible } from '@/utils/rendez-vous'
import { telephone_affiche, titre_telephone } from '@/utils/telephone'

// Page « Générer un Bon » : même tableau compact que la carte « Patients » du tableau de bord (styles partagés
// _table-compacte.scss) — Patient (« + » pour les détails, nom pour choisir), Sexe / âge, Téléphone, Assurance,
// N° carte d'assurance, colonne Consultation (pastilles douces tc-, mêmes seuils de couleur qu'avant : danger
// < 5 j, warning < 10 j, success ≥ 10 j, expiré masqué), action « Choisir ». Recherche côté Clinique différée à
// la saisie, immédiate à Entrée ; pagination de la Clinique.

export const DELAI_SAISIE = 300

export const COLONNES = [
    { key: 'patient_nom', label: 'Patient' },
    { key: 'sexe_age', label: 'Sexe / âge' },
    { key: 'telephone', label: 'Téléphone' },
    { key: 'assurance', label: 'Assurance' },
    { key: 'numero_carte_assurance', label: 'N° carte' },
    { key: 'consultation', label: 'Consultation' }
]

const texte = valeur => (valeur === null || valeur === undefined ? '' : String(valeur).trim())

export default {
    name: "choice-patient",
    components: {
        ModalCreerPatient: () => import('@/components/creer-patient-modal')
    },
    props: ["type"],
    data() {
        return {
            show_state: 0,
            assur_selected: '',
            filter: "",
            perPage: -1,
            currentPage: 1,
            total_pages: 0,
            total: 0,
            url_to_go: "",

            patients: [],
            ouverts: [],
            rendez_vous: {},
            patient_loading: true,
            patient_empty: false,
            search_filter: {
                with_consultation: true
            },
            search_timer: null,
            detruit: false,
            sequence: 0,
            creationOuverte: false
        };
    },

    watch: {
        filter() {
            if (this.filter == '') {
                this.search_filter.search_term = ''
                this.currentPage = 1
                this.search_filter.page = this.currentPage
                this.refreshListePatient()
            }
        }
    },

    computed: {
        colonnes() {
            return COLONNES
        },
        selection_resume() {
            if (this.$store.getters['typeActionSelected'] !== 'bon_consultation') return 'Analyses ou examens sélectionnés'
            const consultation = this.$store.getters['typeConsSelected'] || {}
            return consultation.consult_name || consultation.nom || 'Consultation sélectionnée'
        }
    },

    mounted() {
        this.$store.commit("SET_PATIENT", {});

        this.refreshListePatient()

        //url to go after selection
        let action_selected = this.$store.getters["typeActionSelected"];
        if (action_selected == "bon_consultation") {
            this.url_to_go = { name: 'Bon consultation' }
        } else if (action_selected == "bon_medical") {
            this.url_to_go = { name: 'Bon medical' }
        }
    },

    beforeDestroy() {
        this.detruit = true
        this.sequence++
        clearTimeout(this.search_timer)
        this.search_timer = null
    },

    methods: {
        async ouvrirCreationPatient() {
            const module = await import('@/components/creer-patient-modal')
            this.$options.components.ModalCreerPatient = module.default
            this.creationOuverte = true
            this.$nextTick(() => $('#add-patient').modal('show'))
        },
        retour_catalogue() {
            return this.$router.push({ name: 'Tableau de bord' }).then(() => {
                this.$store.dispatch('setQuickActionsDropdown', true)
            })
        },

        refreshListePatient() {
            if (this.detruit) return Promise.resolve()
            const sequence = ++this.sequence
            this.patient_loading = true

            return store_patient.getListeAllPatient(this.search_filter).then((patients) => {
                if (this.detruit || sequence !== this.sequence) return
                this.patients = patients.data
                this.total_pages = patients.last_page
                this.total = Number(patients.total) || patients.data.length
                this.ouverts = this.ouverts.filter(id => patients.data.some(patient => patient.patient_id === id))
                this.rendez_vous = {}
                this.ouverts.forEach(id => this.charger_rendez_vous(id))

                if (this.patients.length == 0) {
                    this.patient_empty = true
                } else {
                    this.patient_empty = false
                }

                this.patient_loading = false
            }).catch(() => {
                if (this.detruit || sequence !== this.sequence) return
                this.patients = []
                this.total = 0
                this.patient_empty = true
                this.patient_loading = false
            })
        },

        // Recherche différée à la saisie (300 ms), immédiate à Entrée — toujours côté Clinique
        chercher() {
            clearTimeout(this.search_timer)
            this.search_timer = setTimeout(() => {
                this.search_timer = null
                this.rechercher_maintenant()
            }, DELAI_SAISIE)
        },

        rechercher_maintenant() {
            this.currentPage = 1
            this.search_filter.page = this.currentPage
            this.search_filter.search_term = this.filter.trim()
            return this.refreshListePatient()
        },

        // recupérer de l'élément enfant, le nouveau patient créé
        onChildPassNewPatient(value) {
            store_patient.invaliderListePatients()
            this.filter = value.nom + " " + value.prenoms;
        },

        choosePatient: function(patient_data) {

            const selected_patient = {
                id: parseInt(patient_data.patient_id),
                nom: patient_data.patient_nom,
                nom_patient: patient_data.patient_nom,
                prenoms: "",
                sexe: patient_data.sexe,
                telephone_mobile: patient_data.patient_telephone,
                age: patient_data.age,
                num_dossier: patient_data.patient_code
            }
            this.$store.commit("SET_CHOSEN_PATIENT", selected_patient);

            this.$router.push(this.url_to_go)
        },

        // « + » de la ligne : détails du patient sous la ligne (dossier, naissance, adresse, souscripteur…)
        est_ouvert(id) {
            return this.ouverts.indexOf(id) !== -1
        },

        basculer_details(id) {
            if (this.est_ouvert(id)) {
                this.ouverts = this.ouverts.filter(item => item !== id)
            } else {
                this.ouverts = this.ouverts.concat([id])
                if (!this.rendez_vous[id]) this.charger_rendez_vous(id)
            }
        },

        charger_rendez_vous(id) {
            const en_cours = { chargement: true, erreur: '', prochain: null }
            this.$set(this.rendez_vous, id, en_cours)
            return store_rendez_vous.getProchainPatient(id).then(response => {
                if (this.detruit || this.rendez_vous[id] !== en_cours) return
                if (!response || !response.success || !response.data) throw new Error('Réponse invalide')
                this.$set(this.rendez_vous, id, {
                    chargement: false,
                    erreur: response.data.disponible === false ? 'Rendez-vous indisponibles.' : '',
                    prochain: response.data.prochain || null
                })
            }).catch(() => {
                if (this.detruit || this.rendez_vous[id] !== en_cours) return
                this.$set(this.rendez_vous, id, { chargement: false, erreur: 'Impossible de charger les rendez-vous.', prochain: null })
            })
        },

        prochain_rendez_vous(id) {
            return this.rendez_vous[id] || { chargement: false, erreur: '', prochain: null }
        },

        date_rendez_vous(ligne) {
            return date_rdv_lisible(ligne)
        },

        id_details(patient) {
            return 'bon-patients-details-' + this._uid + '-' + patient.patient_id
        },

        // La Clinique peut encore renvoyer « H » ; l'affichage reste « M » dans la Caisse.
        sexe_age(patient) {
            const brut = String((patient && patient.sexe) || '').trim()
            const initiale = brut ? brut.charAt(0).toUpperCase() : ''
            const court = initiale === 'H' ? 'M' : (initiale || '—')
            return court + ' / ' + (patient.age || '—')
        },

        // Téléphone du patient, sinon celui de l'accompagnant avec la filiation, sinon « — »
        telephone(patient) {
            return telephone_affiche(patient, 'patient_telephone')
        },

        titre_telephone(patient) {
            return titre_telephone(patient, 'patient_telephone')
        },

        consultations_valides(patient) {
            return (patient.consultations || []).filter(consultation => consultation.type_consultation && consultation.jour_restant !== 'Expiré')
        },

        validite_consultation(consultation) {
            const jours = Number(consultation.jour_restant)
            if (jours > 0) return `${consultation.type_consultation} (${jours} ${jours === 1 ? 'jr restant' : 'jrs restants'})`
            const duree = texte(consultation.duree_in_time)
            return `${consultation.type_consultation} (${duree || 'aujourd’hui'})`
        },

        details(patient) {
            const derniere = patient.derniere_consultation || null
            const naissance = texte(patient.date_naissance).substr(0, 10)
            const adresse = [texte(patient.adresse), texte(patient.quartier)].filter((valeur, index, liste) => valeur && liste.indexOf(valeur) === index).join(', ')
            const accompagnant = [texte(patient.accompagnant_nom) + (texte(patient.accompagnant_filiation) ? ' (' + texte(patient.accompagnant_filiation) + ')' : ''), texte(patient.accompagnant_telephone)].filter(valeur => valeur).join(' · ')
            const a_prevenir = [texte(patient.personne_a_prevenir_nom), texte(patient.personne_a_prevenir_telephone)].filter(valeur => valeur).join(' · ')
            return [
                ['Dernière consultation', derniere && derniere.date_consultation ? `${date_lisible(derniere.date_consultation)}${derniere.type_consultation ? ' · ' + derniere.type_consultation : ''}` : ''],
                ['Médecin consulté', derniere && derniere.medecin_nom],
                ['N° dossier', texte(patient.patient_code)],
                ['Date de naissance', /^\d{4}-\d{2}-\d{2}$/.test(naissance) ? date_lisible(naissance) : ''],
                ['Adresse / quartier', adresse],
                ['Société souscriptrice', texte(patient.souscripteur)],
                ['Accompagnant', accompagnant],
                ['Personne à prévenir', a_prevenir]
            ].map(detail => [detail[0], detail[1] || '—'])
        },

        /**
         * Show select options in dropdown
         * @param {int} j_state
         * @param {string} selector
         */
        openSelectOption(j_state, selector) {

            if (this.show_state == 0) {
                $('.' + selector).fadeIn();
                $('#' + selector).removeClass('animate__fadeOutTop');
                $('#' + selector).addClass('animate__fadeInTop');
            } else {
                $('#' + selector).removeClass('animate__fadeInTop');
                $('#' + selector).addClass('animate__fadeOutTop');
                $('.' + selector).fadeOut();
            }

            if (j_state == 0) {
                j_state = 1;
            } else {
                j_state = 0;
            }
            this.show_state = j_state;
        },

        /**
         * Select option in dropdown
         * @param {string} selected_value
         * @param {string} selector
         * @param {string} model_selector
         */
        selectOption(selected_value, selected_id, selector, model_selector) {
            switch (model_selector) {
                case 'assur':
                    this.assur_selected = selected_value;
                    this.assureur = selected_id
                    break;
            }

            $('#' + selector).removeClass('animate__fadeInTop');
            $('#' + selector).addClass('animate__fadeOutTop');
            $('.' + selector).fadeOut();

            this.show_state = 0;
        },

        /**
         * Close Modal
         * @param {*} selector
         */
        closeModal(selector) {
            closeModal.closeModal(selector);
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.search_filter.page = this.currentPage
                this.refreshListePatient()
            }
        },

        nextPage() {
            if (this.currentPage < this.total_pages) {
                this.currentPage++;
                this.search_filter.page = this.currentPage
                this.refreshListePatient()
            }
        },

        gotoPage(page) {
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.search_filter.page = this.currentPage
                this.refreshListePatient()
            }
        },

        searchPatient() {
            this.rechercher_maintenant()
        }
    },
};
